import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image/withIEPolyfill"

export default function Image({ path, className, caption, alt, imgStyle }) {
  const data = useStaticQuery(
    graphql`
      query {
        images: allFile {
          edges {
            node {
              relativePath
              name
              childImageSharp {
                fluid(maxWidth: 3000, quality: 100) {
                  ...GatsbyImageSharpFluid
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        }
      }
    `
  )
  const image = data.images.edges.find(item =>
    item.node.relativePath.includes(path)
  )
  if (!image) {
    return null
  }
  const fluid = image.node.childImageSharp.fluid
  return (
    <>
      <Img
        alt={alt}
        fluid={fluid}
        objectFit="cover"
        objectPosition="50% 50%"
        className={className ? className : null}
        imgStyle={imgStyle}
      />
      {caption ? <p className="caption">{caption}</p> : null}
    </>
  )
}
